import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const Notification = lazy(() => import("../pages/notification"));
const TestLogs = lazy(() => import("../pages/test-logs"));
const Testing = lazy(() => import("../pages/testing"));
const RequestLogs = lazy(() => import("../pages/request-logs"));
const Schedules = lazy(() => import("../pages/schedules"));
const LiveLogs = lazy(() => import("../pages/live-logs"));
const Dashboard = lazy(() => import("../pages/dashboard"));

export const NotificationRouter = [
  {
    path: "/notification",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "testing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Testing />
          </Suspense>
        ),
      },
      {
        path: "list",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Notification />
          </Suspense>
        ),
      },
      {
        path: "test-logs",
        element: (
          <Suspense fallback={<Backdrop />}>
            <TestLogs />
          </Suspense>
        ),
      },
      {
        path: "request-logs",
        element: (
          <Suspense fallback={<Backdrop />}>
            <RequestLogs />
          </Suspense>
        ),
      },
      {
        path: "schedules",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Schedules />
          </Suspense>
        ),
      },
      {
        path: "live-logs",
        element: (
          <Suspense fallback={<Backdrop />}>
            <LiveLogs />
          </Suspense>
        ),
      },
    ],
  },
];
